import React from 'react';

function ViewPage(props) {
  	const { history, loading, location, onSetLoading, showNotification } = props	
	console.log(props);

  return (
    <div>
      <h2>View Entry Summary - dummy page</h2>

    </div>
  );
};

export default ViewPage;